<template>
    <div>
        <div v-show="isMain">
            <div class="white-background list-top-margin">
            <!-- 面包屑导航 -->
            <div class="page-top">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>基础数据</el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span style="color:#000;font-weight:bold;">物料清单</span>
                </el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 搜索筛选 -->
            <el-form :model="form" class="user-search" label-width="110px" size="small">
                <el-row>
                <el-col :span="7">
                    <el-form-item label="父项产品编号">
                    <el-input size="small" v-model="form.parentId" placeholder="请输入父项产品编号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="父项产品名称">
                    <el-input size="small" v-model="form.parentName" placeholder="请输入父项产品名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="父项产品规格">
                    <el-input size="small" v-model="form.parentSpecs" placeholder="请输入父项产品名称"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="3" class="text-align-right">
                    <el-button size="small" type="primary" icon="el-icon-search" @click="getdata">查询</el-button>
                </el-col>
                </el-row>
                <el-row class="search-row" v-show="!isFold">
                    <el-col :span="7">
                        <el-form-item label="子项产品编号">
                            <el-input size="small" v-model="form.childId" placeholder="请输入子项产品编号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="子项产品名称">
                            <el-input size="small" v-model="form.childName" placeholder="请输入子项产品名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="子项产品规格">
                            <el-input size="small" v-model="form.childSpecs" placeholder="请输入子项产品名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="备注">
                            <el-input size="small" v-model="form.remark" placeholder="请输入备注"></el-input>
                        </el-form-item>
                    </el-col>


                </el-row>
                <el-divider>
                <i :class="!isFold?'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold"></i>
                </el-divider>
            </el-form>
            </div>

            <div class="white-background">
                <el-row class="tbl-btn">
                <el-col :span="12" class="tbl-btn-left">
                    <el-button size="small" type="primary" icon="el-icon-plus" @click="createProduct">创建物料清单</el-button>
                    <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
                      <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="small" type="primary" plain icon="el-icon-download">导入</el-button>
                    <el-button size="small" type="primary" plain icon="el-icon-upload2">导出</el-button>
                    <!-- <el-button type="text" icon="el-icon-s-data" @click="viewImportLog">查看导入日志</el-button> -->
                    <!-- <el-button type="text" icon="el-icon-edit-outline">编辑打印模板</el-button>
                    <el-button type="text" icon="el-icon-tickets">自定义事件</el-button> -->
                </el-col>
                <!-- <el-col :span="12" class="tbl-btn-right">
                    <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
                </el-col> -->
                </el-row>
                <!--列表-->
                <el-table
                size="small"
                :data="listData"
                highlight-current-row
                v-loading="loading"
                stripe
                border
                :header-cell-style="_headerStyle"
                element-loading-text="加载中"
                style="width: 100%;"
                @selection-change="handleTblSelectionChange"
                >
                <el-table-column align="left" type="selection" width="60"></el-table-column>
                <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
                <el-table-column sortable prop="deptName" label="父项产品编号" width="150">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.parentInfo.productCode" placement="top">
                          <span class="txt-overflow">{{scope.row.parentInfo.productCode}}</span>
                      </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="父项产品名称" width="150">
                  <template slot-scope="scope">
                      <el-tooltip :content="scope.row.parentInfo.productName" placement="top">
                          <span class="txt-overflow">{{scope.row.parentInfo.productName}}</span>
                      </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="父项产品规格" width="150">
                  <template slot-scope="scope">
                          <span class="txt-overflow">{{scope.row.parentInfo.specs}}</span>
                    </template>
                </el-table-column>
                <el-table-column  label="父项单位" width="80">
                  <template slot-scope="scope">
                        <span class="txt-overflow">{{scope.row.parentInfo.unit}}</span>
                    </template>
                </el-table-column>
                <el-table-column  label="子项产品编号" width="120">
                  <template slot-scope="scope">
                      <el-tooltip :content="scope.row.childrenInfo.productCode" placement="top">
                          <span class="txt-overflow">{{scope.row.childrenInfo.productCode}}</span>
                      </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column  label="子项产品名称" width="120">
                  <template slot-scope="scope">
                      <el-tooltip :content="scope.row.childrenInfo.productName" placement="top">
                          <span class="txt-overflow">{{scope.row.childrenInfo.productName}}</span>
                      </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column  label="子项产品规格" width="120">
                  <template slot-scope="scope">
                          <span class="txt-overflow">{{scope.row.childrenInfo.specs}}</span>
                    </template>
                </el-table-column>
                <el-table-column  label="子项单位" width="100">
                  <template slot-scope="scope">
                        <span class="txt-overflow">{{scope.row.childrenInfo.unit}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="unitUsage" label="单位用量" width="100"></el-table-column>
                <el-table-column sortable prop="remark" label="备注" width="120"></el-table-column>
                <el-table-column sortable prop="createTime" label="创建时间" width="150"></el-table-column>
                <el-table-column prop="creater" label="创建人" width="80"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" width="150"></el-table-column>
                <el-table-column align="left" label="操作" min-width="190" fixed="right">
                    <template slot-scope="scope">
                    <el-tooltip content="编辑">
                        <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-edit"
                        circle
                        @click="handleEdit(scope.$index, scope.row)"
                        ></el-button>
                    </el-tooltip>
                    <el-tooltip content="删除">
                        <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click="handleDelete(scope.$index, scope.row)"
                        ></el-button>
                    </el-tooltip>
                    </template>
                </el-table-column>
                </el-table>
                <!-- 分页组件 -->
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
            </div>
      </div>
      <ImportLog v-show="!isMain" :menuName="menuName" @goBack="goBack"></ImportLog>


    <CreateMaterialList :diaVisible="createProductPanVisible" @done="productSave" :userData="userData" :mode="mode" :editRow="editRow"></CreateMaterialList>
  </div>
</template>
<script>
import { materialGetList,materialDelete ,materialBatchDelete} from '@/api/basicData'
import Pagination from "@/components/Pagination";
import ImportLog from "@/components/importLog";
import CreateMaterialList from '@/views/basicData/materialList/createMaterialList';
export default {
  name:'MaterialList',
  components:{
    Pagination,
    CreateMaterialList,
    ImportLog
  },
  data() {
    return {
      menuName:{
        first:'基础数据',
        second:'物料清单',
        three:'导入日志',
      },
      form: {},
      orderStatusList: [
        {
          label: "自制",
          value: "0"
        },
        {
          label: "外购",
          value: "1"
        },
        {
          label: "委外",
          value: "2"
        }
      ],
      isFold: true,
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      createProductPanVisible:false,
      isMain:true,
      userData:{},
      mode:'',
      editRow:{},
    };
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
    }
    this.getdata()
  },
  methods: {
    getdata() {
      this.loading = true
      var params = {
        condition: {
          remark: this.form.remark,
          factoryId: this.userData.factoryId,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      if(this.form.childId){
        params.condition.childrenInfo = {
          productCode: this.form.childId,
          productName: this.form.childName,
          specs: this.form.childSpecs
        }
      }
      if(this.form.parentId){
        params.condition.parentInfo = {
          productCode: this.form.parentId,
          productName:this.form.parentName,
          specs: this.form.parentSpecs
        }
      }
      materialGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    fold() {
      this.isFold = !this.isFold;
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },
     // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    createProduct(){
      this.createProductPanVisible = true;
      this.mode = 'create'
    },
    productSave(options){
      if(options && options.type == 'save'){
        this.getdata()
      }
      this.createProductPanVisible =false;
      this.editRow = {}
    },
    viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    handleDelete(index,row){
      this.$confirm('确认删除物料？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          // const pageLoading = this.openLoading(); //调用方法，打开loading遮罩层
          materialDelete(row._id).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
              // pageLoading.close();
          }).catch(err => {
            // pageLoading.close();
            this.$message.error('删除失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          materialBatchDelete(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    handleEdit: function(index, row) {
      this.mode = 'edit'
      this.editRow = row
      this.createProductPanVisible = true
    },
  }
}
</script>
<style scoped>
    .page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/basicData/materialList/MaterialList.vue